module.exports = __webpack_public_path__ + "static/media/upload.38457281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/upload.svg
// module id = 1264
// module chunks = 0